<template>
  <div class="hse ytcert">
    <router-view></router-view>
    <!-- 底部导航栏 -->
    <van-tabbar v-model="tabActive" fixed safe-area-inset-bottom @change="tabChange">
      <van-tabbar-item icon="home-o">数据中心</van-tabbar-item>
      <van-tabbar-item icon="scan" color="#fff">扫码查</van-tabbar-item>
      <van-tabbar-item icon="user-o">个人中心</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import Vue from "vue";
import { Tabbar, TabbarItem, Icon } from "vant";
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Icon);
import { getWxConfigParams } from "../services/api/index";
const wx = require("weixin-js-sdk");
import util from "../utils";
export default {
  data() {
    return {
      tabActive: 0,
    };
  },
  created() {
    this.getWxConfig();
  },
  methods: {
    async getWxConfig() {
      // const url = window.location.href.split("#")[0];
      const url = "https://cvii1314.cn/";
      const res = await getWxConfigParams(url);
      if (res.code == 200) {
        util.wxConfig(res.data);
      }
    },
    toPage(url) {
      this.$router.push({
        path: url,
      });
    },
    tabChange(index) {
      this.tabActive = index;
      switch (index) {
        case 0:
          this.toPage("/ytCert/certHome");
          break;
        case 1:
          this.scan();
          break;
        case 2:
          this.toPage("/ytCert/certMy");
          break;
      }
    },
    scan() {
      console.log("扫码查询");
      wx.ready(() => {
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果
          scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: (res) => {
            const result = res.resultStr; // 当needResult为1时，扫码返回的结果
            console.log("扫码结果：", result);
          },
          fail: (err) => {
            console.error("扫码失败：", err);
          },
        });
      });
    },
  },
  onLoad() {},
};
</script>

<style scoped>
.hse {
  /* position: relative;
  min-height: 100vh; */
  background-color: #f5f5f5;
  padding-bottom: 30px; /* 为底部导航栏留出空间 */
  height: 100%;
  overflow: hidden;
  width: 100%;
}
/* 底部导航栏 */
.van-tabbar {
  position: fixed;
  bottom: 0;
  width: 100%;
}
</style>